import { TERMS_TOP_ROW_CARD_HEIGHT } from "@/components/home/terms-card-spacing";
import { liveHomeCopy as enLiveHomeCopy } from "@/content/pages/en/live-home";
import { cn } from "@/lib/utils";

import type { TermsCopy } from "./types";

/** "Choose how you repay" — dark lifestyle photo with a black left-scrim behind
 * the white copy (Figma desktop 6055:30149 / mobile 4081:22980). */
export function StaticRepaymentCard({
  copy = enLiveHomeCopy.terms,
}: {
  copy?: TermsCopy;
}) {
  return (
    <div
      className={cn(
        "border-grey-100 bg-grey-50 relative overflow-hidden rounded-2xl border [--image-blur-reveal:0%] hover:[--image-blur-reveal:45%] motion-safe:transition-[--image-blur-reveal] motion-safe:duration-[1200ms] motion-safe:[transition-timing-function:cubic-bezier(0.22,1,0.36,1)]",
        TERMS_TOP_ROW_CARD_HEIGHT
      )}
    >
      {/*
       * Lifestyle photo (Figma "20241218_Wayflyer_Lifestyle_023") — the subject
       * sits on the right; the card is left-aligned onto a ~160% crop so she
       * lands at ~77%. Sharp photo per Figma 8868:38097 (no blur).
       */}
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src="https://cdn.sanity.io/images/1aendizt/redesign/b7fcc0027248be320573d0214c61c87cd62e9c54-1600x800.jpg"
        alt=""
        aria-hidden
        className="absolute -top-1 left-0 h-[calc(100%+8px)] w-[167%] max-w-none object-cover lg:top-0 lg:h-full lg:w-[160%]"
      />
      {/* Flat blue tint (Figma "linear-gradient(90deg, rgba(0,30,255,0.08))"). */}
      <span aria-hidden className="absolute inset-0 bg-[#001eff]/[0.08]" />
      {/* Black left-scrim so the white copy reads (angles/stops per Figma). */}
      <span
        aria-hidden
        className="absolute inset-0 lg:hidden"
        style={{
          backgroundImage:
            "linear-gradient(100.212deg, #000 18.348%, rgba(0,0,0,0) 50.196%)",
        }}
      />
      <span
        aria-hidden
        className="absolute inset-0 hidden lg:block"
        style={{
          backgroundImage:
            "linear-gradient(98.2065deg, #000 15.54%, rgba(0,0,0,0) 54.014%)",
        }}
      />
      {/* Blur reveal on hover — same pattern as about-us leadership portraits:
          backdrop-blur masked by a gradient that sweeps up from the bottom. */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 z-[1] backdrop-blur-[4px]"
        style={{
          maskImage:
            "linear-gradient(to top, black max(calc(var(--image-blur-reveal) - 20%), 0%), transparent var(--image-blur-reveal))",
          WebkitMaskImage:
            "linear-gradient(to top, black max(calc(var(--image-blur-reveal) - 20%), 0%), transparent var(--image-blur-reveal))",
        }}
      />
      <div className="relative z-[2] flex flex-col gap-3 px-[30px] pt-[25px] lg:px-10 lg:pt-[55px]">
        <h3 className="text-[20px] leading-[1.2] tracking-[-0.04em] text-white lg:text-[24px]">
          {copy.repaymentTitle}
        </h3>
        <p className="max-w-[188px] text-[14px] leading-[1.5] tracking-[-0.02em] text-white lg:max-w-[290px] lg:text-[16px]">
          {copy.repaymentDescription}
        </p>
      </div>
    </div>
  );
}
